import script from "./TabComponentV3.vue?vue&type=script&setup=true&lang=js"
export * from "./TabComponentV3.vue?vue&type=script&setup=true&lang=js"

import "./TabComponentV3.vue?vue&type=style&index=0&id=87ad89a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ad89a2"]])

export default __exports__